import React from 'react'

const GPServiceProfileIcon = (
  <>
    <g clipPath="url(#clip0_2797_27054)">
      <path
        d="M3.33337 7.5V2.91667C3.33337 2.80616 3.37727 2.70018 3.45541 2.62204C3.53355 2.5439 3.63953 2.5 3.75004 2.5H5.41671C5.52721 2.5 5.63319 2.5439 5.71133 2.62204C5.78948 2.70018 5.83337 2.80616 5.83337 2.91667V5.45458L3.33337 7.5Z"
        fill="#F74B3B"
      />
      <path
        d="M9.99996 1.25L2.91663 7.54625V18.3333C2.91663 18.5543 3.00442 18.7663 3.1607 18.9226C3.31698 19.0789 3.52895 19.1667 3.74996 19.1667H16.25C16.471 19.1667 16.6829 19.0789 16.8392 18.9226C16.9955 18.7663 17.0833 18.5543 17.0833 18.3333V7.54625L9.99996 1.25Z"
        fill="#E3E3E3"
      />
      <path
        d="M19.1666 10C19.063 10 18.963 9.96141 18.8862 9.89166L9.99998 1.81291L1.11373 9.89166C1.0319 9.96603 0.923877 10.0049 0.813426 9.99958C0.702975 9.9943 0.599143 9.94537 0.524772 9.86354C0.450401 9.78171 0.411582 9.67369 0.416857 9.56323C0.422131 9.45278 0.471066 9.34895 0.552897 9.27458L9.71956 0.941246C9.79628 0.871445 9.89626 0.832764 9.99998 0.832764C10.1037 0.832764 10.2037 0.871445 10.2804 0.941246L19.4471 9.27458C19.5095 9.33113 19.5533 9.40525 19.5727 9.48718C19.5921 9.56912 19.5863 9.65502 19.5559 9.73356C19.5255 9.81211 19.4721 9.87961 19.4026 9.92717C19.3331 9.97473 19.2509 10.0001 19.1666 10Z"
        fill="#FF7163"
      />
      <path
        d="M11.6666 13.75H8.33329C8.22279 13.75 8.1168 13.7939 8.03866 13.872C7.96052 13.9502 7.91663 14.0562 7.91663 14.1667V19.1667H12.0833V14.1667C12.0833 14.0562 12.0394 13.9502 11.9613 13.872C11.8831 13.7939 11.7771 13.75 11.6666 13.75Z"
        fill="#BF8C5A"
      />
      <path
        d="M11.6666 11.2501H8.33329C8.22279 11.2501 8.1168 11.2062 8.03866 11.128C7.96052 11.0499 7.91663 10.9439 7.91663 10.8334V8.33341C7.91663 8.22291 7.96052 8.11693 8.03866 8.03879C8.1168 7.96065 8.22279 7.91675 8.33329 7.91675H11.6666C11.7771 7.91675 11.8831 7.96065 11.9613 8.03879C12.0394 8.11693 12.0833 8.22291 12.0833 8.33341V10.8334C12.0833 10.9439 12.0394 11.0499 11.9613 11.128C11.8831 11.2062 11.7771 11.2501 11.6666 11.2501Z"
        fill="#3AACE9"
      />
      <path
        d="M5.96414 19.1666C6.15335 18.7713 6.25104 18.3384 6.24995 17.9001C6.24886 17.4619 6.14902 17.0295 5.95784 16.6351C5.76666 16.2407 5.48907 15.8945 5.14569 15.6222C4.80231 15.3498 4.40197 15.1584 3.97442 15.0621C3.54688 14.9657 3.10311 14.967 2.67612 15.0657C2.24912 15.1645 1.84987 15.3582 1.50803 15.6324C1.16619 15.9067 0.890555 16.2545 0.701608 16.6499C0.51266 17.0454 0.415258 17.4783 0.41664 17.9166C0.417058 18.3494 0.514743 18.7766 0.702474 19.1666H5.96414Z"
        fill="#78D478"
      />
      <path
        d="M19.2975 19.1666C19.5103 18.722 19.607 18.2307 19.5784 17.7386C19.5499 17.2466 19.3972 16.7697 19.1344 16.3527C18.8717 15.9356 18.5075 15.592 18.076 15.3538C17.6444 15.1156 17.1596 14.9907 16.6667 14.9907C16.1738 14.9907 15.6889 15.1156 15.2573 15.3538C14.8258 15.592 14.4616 15.9356 14.1989 16.3527C13.9362 16.7697 13.7834 17.2466 13.7549 17.7386C13.7264 18.2307 13.823 18.722 14.0358 19.1666H19.2975Z"
        fill="#78D478"
      />
    </g>
    <defs>
      <clipPath id="clip0_2797_27054">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </>
)

export default GPServiceProfileIcon
